export const FAILED_GET_SPORT = 'FAILED_GET_SPORT'
export const FAILED_GET_SPORT_EVENT_TEMPLATES = 'FAILED_GET_SPORT_EVENT_TEMPLATES'
export const FAILED_GET_SPORTS = 'FAILED_GET_SPORTS'
export const RECEIVE_GET_SPORT = 'RECEIVE_GET_SPORT'
export const RECEIVE_GET_SPORT_EVENT_TEMPLATES = 'RECEIVE_GET_SPORT_EVENT_TEMPLATES'
export const RECEIVE_GET_SPORTS = 'RECEIVE_GET_SPORTS'
export const REQUEST_GET_SPORT = 'REQUEST_GET_SPORT'
export const REQUEST_GET_SPORT_EVENT_TEMPLATES = 'REQUEST_GET_SPORT_EVENT_TEMPLATES'
export const REQUEST_GET_SPORTS = 'REQUEST_GET_SPORTS'
